export default "__VITE_ASSET__DAmfpFAB__"